import {
  Companion_instance1iw39v478z3sa as Companion_instance,
  Companion_instance2xs5meuo4uk7b as Companion_instance_0,
  Nothing_getInstance1x7nejv3dwhdr as Nothing_getInstance,
  Companion_instance16cifvdjsintt as Companion_instance_1,
  Companion_instance3q5qrbb8dvim2 as Companion_instance_2,
  Modification18t7xkem2wa8b as Modification,
  Companion_instance7x85vjcu6250 as Companion_instance_3,
  Chain19a4phelb7wvt as Chain,
  IfNotNull38wuwth0boumg as IfNotNull,
  Assign2jm8flaivtcon as Assign,
  CoerceAtMostq5a6wez8cbc3 as CoerceAtMost,
  CoerceAtLeast2ab0yoy33rfu as CoerceAtLeast,
  Increment1pfryvb4zoayz as Increment,
  Multiply1xe85fphx1al8 as Multiply,
  AppendString16i0d1y6ycmfz as AppendString,
  AppendRawString34ujb3ehxmc69 as AppendRawString,
  ListAppend33qq4czoszla7 as ListAppend,
  ListRemove19cmtj4n1o925 as ListRemove,
  ListRemoveInstances2ej6cwqnkecnk as ListRemoveInstances,
  ListDropFirst19o4xwpphf8ln as ListDropFirst,
  ListDropLastpn5v16j4rov9 as ListDropLast,
  SetAppend21wbdzlb467lu as SetAppend,
  SetRemove34o7bveplt00y as SetRemove,
  SetRemoveInstancesjh7gkqqf27pt as SetRemoveInstances,
  SetDropFirst2rqppx5fk611e as SetDropFirst,
  SetDropLastow7b3ky3amx8 as SetDropLast,
  Combineenmtpkmzz4x as Combine,
  RemoveKeys367ctzny0wdt9 as RemoveKeys,
  Companion_instance3bnzzufvyr983 as Companion_instance_4,
  Companion_instance3okjoeswc063e as Companion_instance_5,
  Companion_instance3jp69gxf6v3e3 as Companion_instance_6,
  Companion_instanced9y0ghw4y3f4 as Companion_instance_7,
  Companion_instance2gc3grqkqb8ba as Companion_instance_8,
  Companion_instanceh5qpv80ys58j as Companion_instance_9,
  Companion_instancetqr20ikb6k9i as Companion_instance_10,
  Companion_instance1brivik930s8s as Companion_instance_11,
  Companion_instance1skqa9ankg6k1 as Companion_instance_12,
  Companion_instance2dt70m4k7qloa as Companion_instance_13,
  Companion_instance385iatw7zqcbc as Companion_instance_14,
  Companion_getInstance2sdnjo9tz10if as Companion_getInstance,
  Companion_instanceez0w06et8n0z as Companion_instance_15,
  Companion_instance288oh9kic3o9e as Companion_instance_16,
  Companion_instance1fe0vifomrwt0 as Companion_instance_17,
  Companion_instance2ca3a70e9t58s as Companion_instance_18,
  Companion_instancewuhi7j8dzj2n as Companion_instance_19,
  Companion_getInstance7fe8bbmq9v9z as Companion_getInstance_0,
  OnFielduegjwkreacmm as OnField,
  IfIsType2q85mbl9d19gv as IfIsType,
  Nothing3qsizz6tw38jz as Nothing,
  SetPerElement2huwz2o9oppuj as SetPerElement,
  ListPerElement3otxrneyl53yk as ListPerElement,
  Companion_instance1oe56hdndwklm as Companion_instance_20,
} from './Modification.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Option33wwe88i3c121 as Option,
  MySealedClassSerializerpklrcjai1fw6 as MySealedClassSerializer,
  MySealedClassSerializerInterface1lg9fzm3qtbhk as MySealedClassSerializerInterface,
} from './MySealedClassSerializer.mjs';
import {
  listOf1jh22dvmctj1r as listOf,
  listOfNotNull1v4ggfackvuny as listOfNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isComparableviyv6ctzm76u as isComparable,
  isNumberiramasdbon0i as isNumber,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  KSerializerKey32hf92q4tsy3p as KSerializerKey,
  listElement3jy3tr2z6og1q as listElement,
  mapValueElementnslktw4l3iup as mapValueElement,
  nullElement39ujy5fzowmto as nullElement,
  WrappingSerializer1aufse1qyl29g as WrappingSerializer,
} from './SerializationHelpers.mjs';
import {
  get_serializableOptions2omofumtgto14 as get_serializableOptions,
  get_serializableProperties1162nosnaangd as get_serializableProperties,
} from './SerializableProperty.mjs';
import {
  contains3ue2qo8xhmpf1 as contains,
  substringBefore3n7kj60w69hju as substringBefore,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  LIST_getInstance2vniy0f7mmb29 as LIST_getInstance,
  MAP_getInstance3e78m6vf98i66 as MAP_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance18mvmiinmr4hw as Companion_getInstance_1 } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMap140uvy3s5zad8 as KtMap,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { KSerializerWithDefault3c244bl47fg5p as KSerializerWithDefault } from './Defaults.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  serializer1x79l67jvwntn as serializer,
  serializer3u3hsxnenk49x as serializer_0,
  SetSerializert3lb0yy9iftr as SetSerializer,
  MapSerializer11kmegt3g5c1g as MapSerializer,
  get_nullable197rfua9r7fsz as get_nullable,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  StringCompanionObject_instance2dx16b5pp3v3z as StringCompanionObject_instance,
  BooleanCompanionObject_instance2tls5h1cufcrh as BooleanCompanionObject_instance,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import {
  Companion_instance170wh3hu8c61 as Companion_instance_21,
  Conditionlbcfpsbet24r as Condition,
} from './Condition.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1hwzc6m64v1op as serializer_1 } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import {
  listOfvhqybd2zx248 as listOf_0,
  setOf1u3mizs95ngxo as setOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  _SealedTypeDiscriminator___init__impl__jf77jnb2draso4x6g as _SealedTypeDiscriminator___init__impl__jf77jn,
  _SealedTypeDiscriminator___get_serialName__impl__x46m55cpdzns363t1u as _SealedTypeDiscriminator___get_serialName__impl__x46m55,
  variantShortNamey38i8usgp8vx as variantShortName,
} from './SealedTypeDiscriminator.mjs';
import { plus1ogy4liedzq5j as plus_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { setOf45ia9pnfhe90 as setOf_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_stringOptions() {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return stringOptions;
}
var stringOptions;
function get_cache() {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return cache;
}
var cache;
function get_numlist() {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return numlist;
}
var numlist;
function comparableOptions(inner) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = commonOptions(inner);
  var tmp_0 = Companion_instance.serializer_qelnde_k$(inner);
  var tmp_1 = new (Option())(tmp_0, 'CoerceAtLeast', VOID, VOID, 40, comparableOptions$lambda);
  var tmp_2 = Companion_instance_0.serializer_qelnde_k$(inner);
  return plus(tmp, listOf([tmp_1, new (Option())(tmp_2, 'CoerceAtMost', VOID, VOID, 40, comparableOptions$lambda_0)]));
}
function commonOptions(inner) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = Nothing_getInstance().serializer_9w0wvi_k$();
  var tmp_0 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
  var tmp_1 = new (Option())(tmp_0, 'Nothing', VOID, VOID, 0, commonOptions$lambda);
  var tmp_2 = Companion_instance_1.serializer_qelnde_k$(inner);
  var tmp_3 = new (Option())(tmp_2, 'Chain', VOID, VOID, 20, commonOptions$lambda_0);
  var tmp_4 = Companion_instance_2.serializer_qelnde_k$(inner);
  return listOf([tmp_1, tmp_3, new (Option())(tmp_4, 'Assign', VOID, VOID, 50, commonOptions$lambda_1)]);
}
var ModificationSerializerClass;
function ModificationSerializer() {
  if (ModificationSerializerClass === VOID) {
    class $ {
      constructor(inner) {
        var tmp = this;
        var tmp0 = get_cache();
        // Inline function 'kotlin.collections.getOrPut' call
        var key = KSerializerKey().new_com_lightningkite_services_database_KSerializerKey_4fta1q_k$(inner);
        var value = tmp0.get_wei43m_k$(key);
        var tmp_0;
        if (value == null) {
          var answer = new (MySealedClassSerializer())('com.lightningkite.services.database.Modification', () => {
            var tmp;
            if (!(nullElement(inner) == null)) {
              var tmp_0 = ensureNotNull(nullElement(inner));
              tmp = nullableOptions(isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE());
            } else if (substringBefore(inner.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), _Char___init__impl__6a9atx(47)) === 'kotlin.String') {
              tmp = get_stringOptions();
            } else if (get_numlist().contains_aljjnj_k$(inner.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$())) {
              tmp = numberOptions(isInterface(inner, KSerializer()) ? inner : THROW_CCE());
            } else if (Companion_getInstance_1().serialNames_1.contains_aljjnj_k$(inner.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$())) {
              tmp = rawStringOptions(isInterface(inner, KSerializer()) ? inner : THROW_CCE());
            } else if (equals(inner.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), MAP_getInstance())) {
              tmp = stringMapOptions(ensureNotNull(mapValueElement(inner)));
            } else if (equals(inner.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), LIST_getInstance())) {
              tmp = contains(inner.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'Set') ? setOptions(ensureNotNull(listElement(inner))) : listOptions(ensureNotNull(listElement(inner)));
            } else if (!(get_serializableProperties(inner) == null)) {
              tmp = classOptionsReflective(isInterface(inner, KSerializer()) ? inner : THROW_CCE());
            } else if (!(get_serializableOptions(inner) == null)) {
              tmp = polymorphicOptions(isInterface(inner, KSerializer()) ? inner : THROW_CCE());
            } else {
              tmp = comparableOptions(isInterface(inner, KSerializer()) ? inner : THROW_CCE());
            }
            var r = tmp;
            return isInterface(r, KtList()) ? r : THROW_CCE();
          });
          tmp0.put_4fpzoq_k$(key, answer);
          tmp_0 = answer;
        } else {
          tmp_0 = value;
        }
        var tmp_1 = tmp_0;
        tmp.$$delegate_0__1 = isInterface(tmp_1, MySealedClassSerializerInterface()) ? tmp_1 : THROW_CCE();
        this.inner_1 = inner;
      }
      toString() {
        return 'ModificationSerializer(inner=' + toString(this.inner_1) + ')';
      }
      hashCode() {
        return hashCode(this.inner_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ModificationSerializer()))
          return false;
        if (!equals(this.inner_1, other.inner_1))
          return false;
        return true;
      }
      get_options_jecmyz_k$() {
        return this.$$delegate_0__1.get_options_jecmyz_k$();
      }
      get_default_qtagd4_k$() {
        return this.$$delegate_0__1.get_default_qtagd4_k$();
      }
      get_descriptor_wjt6a0_k$() {
        return this.$$delegate_0__1.get_descriptor_wjt6a0_k$();
      }
      serialize_tdyc82_k$(encoder, value) {
        this.$$delegate_0__1.serialize_5ase3y_k$(encoder, value);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_tdyc82_k$(encoder, value instanceof Modification() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        return this.$$delegate_0__1.deserialize_sy6x50_k$(decoder);
      }
    }
    initMetadataForClass($, 'ModificationSerializer', VOID, VOID, [MySealedClassSerializerInterface(), KSerializerWithDefault()]);
    ModificationSerializerClass = $;
  }
  return ModificationSerializerClass;
}
var ModificationChainSerializerClass;
function ModificationChainSerializer() {
  if (ModificationChainSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.Chain');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return ListSerializer(Companion_instance_3.serializer_qelnde_k$(this.inner_1));
      }
      inner_d3p8va_k$(it) {
        return it.modifications_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_d3p8va_k$(it instanceof Chain() ? it : THROW_CCE());
      }
      outer_bc5wm6_k$(it) {
        return Chain().new_com_lightningkite_services_database_Modification_Chain_qdmx0f_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_bc5wm6_k$((!(it == null) ? isInterface(it, KtList()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationChainSerializer');
    ModificationChainSerializerClass = $;
  }
  return ModificationChainSerializerClass;
}
var ModificationIfNotNullSerializerClass;
function ModificationIfNotNullSerializer() {
  if (ModificationIfNotNullSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.IfNotNull');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return Companion_instance_3.serializer_qelnde_k$(this.inner_1);
      }
      inner_jfehje_k$(it) {
        return it.modification_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_jfehje_k$(it instanceof IfNotNull() ? it : THROW_CCE());
      }
      outer_6qf91g_k$(it) {
        return IfNotNull().new_com_lightningkite_services_database_Modification_IfNotNull_mgiwu9_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_6qf91g_k$(it instanceof Modification() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationIfNotNullSerializer');
    ModificationIfNotNullSerializerClass = $;
  }
  return ModificationIfNotNullSerializerClass;
}
var ModificationAssignSerializerClass;
function ModificationAssignSerializer() {
  if (ModificationAssignSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.Assign');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return this.inner_1;
      }
      inner_g6v8z8_k$(it) {
        return it.value_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_g6v8z8_k$(it instanceof Assign() ? it : THROW_CCE());
      }
      outer_nxvwks_k$(it) {
        return Assign().new_com_lightningkite_services_database_Modification_Assign_1ypiqt_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_nxvwks_k$(it);
      }
    }
    initMetadataForClass($, 'ModificationAssignSerializer', VOID, VOID, [KSerializer()]);
    ModificationAssignSerializerClass = $;
  }
  return ModificationAssignSerializerClass;
}
var ModificationCoerceAtMostSerializerClass;
function ModificationCoerceAtMostSerializer() {
  if (ModificationCoerceAtMostSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.CoerceAtMost');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return this.inner_1;
      }
      inner_uovtgy_k$(it) {
        return it.value_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_uovtgy_k$(it instanceof CoerceAtMost() ? it : THROW_CCE());
      }
      outer_adyfzm_k$(it) {
        return CoerceAtMost().new_com_lightningkite_services_database_Modification_CoerceAtMost_yhu95r_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_adyfzm_k$((!(it == null) ? isComparable(it) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationCoerceAtMostSerializer');
    ModificationCoerceAtMostSerializerClass = $;
  }
  return ModificationCoerceAtMostSerializerClass;
}
var ModificationCoerceAtLeastSerializerClass;
function ModificationCoerceAtLeastSerializer() {
  if (ModificationCoerceAtLeastSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.CoerceAtLeast');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return this.inner_1;
      }
      inner_huwx9o_k$(it) {
        return it.value_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_huwx9o_k$(it instanceof CoerceAtLeast() ? it : THROW_CCE());
      }
      outer_adyfzm_k$(it) {
        return CoerceAtLeast().new_com_lightningkite_services_database_Modification_CoerceAtLeast_iwc7nz_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_adyfzm_k$((!(it == null) ? isComparable(it) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationCoerceAtLeastSerializer');
    ModificationCoerceAtLeastSerializerClass = $;
  }
  return ModificationCoerceAtLeastSerializerClass;
}
var ModificationIncrementSerializerClass;
function ModificationIncrementSerializer() {
  if (ModificationIncrementSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.Increment');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return this.inner_1;
      }
      inner_u73liw_k$(it) {
        return it.by_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_u73liw_k$(it instanceof Increment() ? it : THROW_CCE());
      }
      outer_ehtwrn_k$(it) {
        return Increment().new_com_lightningkite_services_database_Modification_Increment_h5xavn_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_ehtwrn_k$(isNumber(it) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationIncrementSerializer');
    ModificationIncrementSerializerClass = $;
  }
  return ModificationIncrementSerializerClass;
}
var ModificationMultiplySerializerClass;
function ModificationMultiplySerializer() {
  if (ModificationMultiplySerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.Multiply');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return this.inner_1;
      }
      inner_kuv1gh_k$(it) {
        return it.by_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_kuv1gh_k$(it instanceof Multiply() ? it : THROW_CCE());
      }
      outer_ehtwrn_k$(it) {
        return Multiply().new_com_lightningkite_services_database_Modification_Multiply_oj02wu_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_ehtwrn_k$(isNumber(it) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationMultiplySerializer');
    ModificationMultiplySerializerClass = $;
  }
  return ModificationMultiplySerializerClass;
}
var ModificationAppendStringSerializerClass;
function ModificationAppendStringSerializer() {
  if (ModificationAppendStringSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor() {
        ModificationAppendStringSerializer_instance = null;
        super('com.lightningkite.services.database.Modification.AppendString');
        ModificationAppendStringSerializer_instance = this;
      }
      getDeferred_py8w4r_k$() {
        return serializer(StringCompanionObject_instance);
      }
      inner_va74no_k$(it) {
        return it.value_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_va74no_k$(it instanceof AppendString() ? it : THROW_CCE());
      }
      outer_56pmvz_k$(it) {
        return AppendString().new_com_lightningkite_services_database_Modification_AppendString_3vq13i_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_56pmvz_k$((!(it == null) ? typeof it === 'string' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForObject($, 'ModificationAppendStringSerializer');
    ModificationAppendStringSerializerClass = $;
  }
  return ModificationAppendStringSerializerClass;
}
var ModificationAppendStringSerializer_instance;
function ModificationAppendStringSerializer_getInstance() {
  if (ModificationAppendStringSerializer_instance === VOID)
    new (ModificationAppendStringSerializer())();
  return ModificationAppendStringSerializer_instance;
}
var ModificationAppendRawStringSerializerClass;
function ModificationAppendRawStringSerializer() {
  if (ModificationAppendRawStringSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor() {
        super('com.lightningkite.services.database.Modification.AppendRawString');
      }
      getDeferred_py8w4r_k$() {
        return serializer(StringCompanionObject_instance);
      }
      inner_itxmq0_k$(it) {
        return it.value_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_itxmq0_k$(it instanceof AppendRawString() ? it : THROW_CCE());
      }
      outer_56pmvz_k$(it) {
        return AppendRawString().new_com_lightningkite_services_database_Modification_AppendRawString_9qsesl_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_56pmvz_k$((!(it == null) ? typeof it === 'string' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationAppendRawStringSerializer', ModificationAppendRawStringSerializer);
    ModificationAppendRawStringSerializerClass = $;
  }
  return ModificationAppendRawStringSerializerClass;
}
var ModificationListAppendSerializerClass;
function ModificationListAppendSerializer() {
  if (ModificationListAppendSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.ListAppend');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return ListSerializer(this.inner_1);
      }
      inner_hlv5pn_k$(it) {
        return it.items_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_hlv5pn_k$(it instanceof ListAppend() ? it : THROW_CCE());
      }
      outer_pkctjj_k$(it) {
        return ListAppend().new_com_lightningkite_services_database_Modification_ListAppend_qrb1tt_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_pkctjj_k$((!(it == null) ? isInterface(it, KtList()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationListAppendSerializer');
    ModificationListAppendSerializerClass = $;
  }
  return ModificationListAppendSerializerClass;
}
var ModificationListRemoveSerializerClass;
function ModificationListRemoveSerializer() {
  if (ModificationListRemoveSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.ListRemove');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return Companion_instance_21.serializer_qelnde_k$(this.inner_1);
      }
      inner_9yu9dr_k$(it) {
        return it.condition_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_9yu9dr_k$(it instanceof ListRemove() ? it : THROW_CCE());
      }
      outer_gq7unn_k$(it) {
        return ListRemove().new_com_lightningkite_services_database_Modification_ListRemove_z7k4od_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_gq7unn_k$(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationListRemoveSerializer');
    ModificationListRemoveSerializerClass = $;
  }
  return ModificationListRemoveSerializerClass;
}
var ModificationListRemoveInstancesSerializerClass;
function ModificationListRemoveInstancesSerializer() {
  if (ModificationListRemoveInstancesSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.ListRemoveInstances');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return ListSerializer(this.inner_1);
      }
      inner_lzggmj_k$(it) {
        return it.items_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_lzggmj_k$(it instanceof ListRemoveInstances() ? it : THROW_CCE());
      }
      outer_pkctjj_k$(it) {
        return ListRemoveInstances().new_com_lightningkite_services_database_Modification_ListRemoveInstances_v0avp_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_pkctjj_k$((!(it == null) ? isInterface(it, KtList()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationListRemoveInstancesSerializer');
    ModificationListRemoveInstancesSerializerClass = $;
  }
  return ModificationListRemoveInstancesSerializerClass;
}
var ModificationListDropFirstSerializerClass;
function ModificationListDropFirstSerializer() {
  if (ModificationListDropFirstSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.ListDropFirst');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return serializer_0(BooleanCompanionObject_instance);
      }
      inner_k19nl0_k$(it) {
        return true;
      }
      inner_edgipe_k$(it) {
        return this.inner_k19nl0_k$(it instanceof ListDropFirst() ? it : THROW_CCE());
      }
      outer_l3jiiy_k$(it) {
        return ListDropFirst().new_com_lightningkite_services_database_Modification_ListDropFirst_5x08li_k$();
      }
      outer_ojvjpq_k$(it) {
        return this.outer_l3jiiy_k$((!(it == null) ? typeof it === 'boolean' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationListDropFirstSerializer');
    ModificationListDropFirstSerializerClass = $;
  }
  return ModificationListDropFirstSerializerClass;
}
var ModificationListDropLastSerializerClass;
function ModificationListDropLastSerializer() {
  if (ModificationListDropLastSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.ListDropLast');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return serializer_0(BooleanCompanionObject_instance);
      }
      inner_trkbsw_k$(it) {
        return true;
      }
      inner_edgipe_k$(it) {
        return this.inner_trkbsw_k$(it instanceof ListDropLast() ? it : THROW_CCE());
      }
      outer_l3jiiy_k$(it) {
        return ListDropLast().new_com_lightningkite_services_database_Modification_ListDropLast_z6iayo_k$();
      }
      outer_ojvjpq_k$(it) {
        return this.outer_l3jiiy_k$((!(it == null) ? typeof it === 'boolean' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationListDropLastSerializer');
    ModificationListDropLastSerializerClass = $;
  }
  return ModificationListDropLastSerializerClass;
}
var ModificationSetAppendSerializerClass;
function ModificationSetAppendSerializer() {
  if (ModificationSetAppendSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.SetAppend');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return SetSerializer(this.inner_1);
      }
      inner_nm3vqj_k$(it) {
        return it.items_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_nm3vqj_k$(it instanceof SetAppend() ? it : THROW_CCE());
      }
      outer_sa4rg5_k$(it) {
        return SetAppend().new_com_lightningkite_services_database_Modification_SetAppend_p0ge6d_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_sa4rg5_k$((!(it == null) ? isInterface(it, KtSet()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationSetAppendSerializer');
    ModificationSetAppendSerializerClass = $;
  }
  return ModificationSetAppendSerializerClass;
}
var ModificationSetRemoveSerializerClass;
function ModificationSetRemoveSerializer() {
  if (ModificationSetRemoveSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.SetRemove');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return Companion_instance_21.serializer_qelnde_k$(this.inner_1);
      }
      inner_3yljcv_k$(it) {
        return it.condition_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_3yljcv_k$(it instanceof SetRemove() ? it : THROW_CCE());
      }
      outer_gq7unn_k$(it) {
        return SetRemove().new_com_lightningkite_services_database_Modification_SetRemove_zidqc7_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_gq7unn_k$(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationSetRemoveSerializer');
    ModificationSetRemoveSerializerClass = $;
  }
  return ModificationSetRemoveSerializerClass;
}
var ModificationSetRemoveInstancesSerializerClass;
function ModificationSetRemoveInstancesSerializer() {
  if (ModificationSetRemoveInstancesSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.SetRemoveInstances');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return SetSerializer(this.inner_1);
      }
      inner_al704r_k$(it) {
        return it.items_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_al704r_k$(it instanceof SetRemoveInstances() ? it : THROW_CCE());
      }
      outer_sa4rg5_k$(it) {
        return SetRemoveInstances().new_com_lightningkite_services_database_Modification_SetRemoveInstances_7ds9nf_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_sa4rg5_k$((!(it == null) ? isInterface(it, KtSet()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationSetRemoveInstancesSerializer');
    ModificationSetRemoveInstancesSerializerClass = $;
  }
  return ModificationSetRemoveInstancesSerializerClass;
}
var ModificationSetDropFirstSerializerClass;
function ModificationSetDropFirstSerializer() {
  if (ModificationSetDropFirstSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.SetDropFirst');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return serializer_0(BooleanCompanionObject_instance);
      }
      inner_vc4gm4_k$(it) {
        return true;
      }
      inner_edgipe_k$(it) {
        return this.inner_vc4gm4_k$(it instanceof SetDropFirst() ? it : THROW_CCE());
      }
      outer_l3jiiy_k$(it) {
        return SetDropFirst().new_com_lightningkite_services_database_Modification_SetDropFirst_uq1ysc_k$();
      }
      outer_ojvjpq_k$(it) {
        return this.outer_l3jiiy_k$((!(it == null) ? typeof it === 'boolean' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationSetDropFirstSerializer');
    ModificationSetDropFirstSerializerClass = $;
  }
  return ModificationSetDropFirstSerializerClass;
}
var ModificationSetDropLastSerializerClass;
function ModificationSetDropLastSerializer() {
  if (ModificationSetDropLastSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.SetDropLast');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return serializer_0(BooleanCompanionObject_instance);
      }
      inner_asu22o_k$(it) {
        return true;
      }
      inner_edgipe_k$(it) {
        return this.inner_asu22o_k$(it instanceof SetDropLast() ? it : THROW_CCE());
      }
      outer_l3jiiy_k$(it) {
        return SetDropLast().new_com_lightningkite_services_database_Modification_SetDropLast_g1stcm_k$();
      }
      outer_ojvjpq_k$(it) {
        return this.outer_l3jiiy_k$((!(it == null) ? typeof it === 'boolean' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationSetDropLastSerializer');
    ModificationSetDropLastSerializerClass = $;
  }
  return ModificationSetDropLastSerializerClass;
}
var ModificationCombineSerializerClass;
function ModificationCombineSerializer() {
  if (ModificationCombineSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.Combine');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_0 = serializer_1(createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
        var tmp$ret$0 = isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
        return MapSerializer(tmp$ret$0, this.inner_1);
      }
      inner_nk5t9k_k$(it) {
        return it.map_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_nk5t9k_k$(it instanceof Combine() ? it : THROW_CCE());
      }
      outer_4gi9pj_k$(it) {
        return Combine().new_com_lightningkite_services_database_Modification_Combine_bmxq2k_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_4gi9pj_k$((!(it == null) ? isInterface(it, KtMap()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationCombineSerializer');
    ModificationCombineSerializerClass = $;
  }
  return ModificationCombineSerializerClass;
}
var ModificationRemoveKeysSerializerClass;
function ModificationRemoveKeysSerializer() {
  if (ModificationRemoveKeysSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Modification.RemoveKeys');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_0 = serializer_1(createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
        var tmp$ret$0 = isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
        return SetSerializer(tmp$ret$0);
      }
      inner_7kqg6j_k$(it) {
        return it.fields_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_7kqg6j_k$(it instanceof RemoveKeys() ? it : THROW_CCE());
      }
      outer_1u2nm3_k$(it) {
        return RemoveKeys().new_com_lightningkite_services_database_Modification_RemoveKeys_5rog8r_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_1u2nm3_k$((!(it == null) ? isInterface(it, KtSet()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationRemoveKeysSerializer');
    ModificationRemoveKeysSerializerClass = $;
  }
  return ModificationRemoveKeysSerializerClass;
}
function nullableOptions(inner) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = commonOptions(get_nullable(inner));
  var tmp_0 = Companion_instance_4.serializer_qelnde_k$(inner);
  return plus(tmp, listOf_0(new (Option())(tmp_0, 'IfNotNull', VOID, VOID, 45, nullableOptions$lambda)));
}
function numberOptions(serializer) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = comparableOptions(serializer);
  var tmp_0 = Companion_instance_5.serializer_qelnde_k$(serializer);
  var tmp_1 = new (Option())(tmp_0, 'Increment', VOID, VOID, 45, numberOptions$lambda);
  var tmp_2 = Companion_instance_6.serializer_qelnde_k$(serializer);
  return plus(tmp, listOf([tmp_1, new (Option())(tmp_2, 'Multiply', VOID, VOID, 45, numberOptions$lambda_0)]));
}
function rawStringOptions(element) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = comparableOptions(element);
  var tmp_0 = Companion_instance_7.serializer_qelnde_k$(element);
  var tmp_1 = setOf('AppendRawString');
  return plus(tmp, listOf_0(new (Option())(tmp_0, 'AppendString', tmp_1, VOID, 45, rawStringOptions$lambda)));
}
function stringMapOptions(element) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = commonOptions(MapSerializer(serializer(StringCompanionObject_instance), element));
  var tmp_0 = Companion_instance_8.serializer_qelnde_k$(element);
  var tmp_1 = new (Option())(tmp_0, 'Combine', VOID, VOID, 45, stringMapOptions$lambda);
  var tmp_2 = Companion_instance_9.serializer_qelnde_k$(element);
  return plus(tmp, listOf([tmp_1, new (Option())(tmp_2, 'RemoveKeys', VOID, VOID, 45, stringMapOptions$lambda_0)]));
}
function setOptions(element) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = commonOptions(SetSerializer(element));
  var tmp_0 = Companion_instance_10.serializer_qelnde_k$(element);
  var tmp_1 = setOf('AppendSet');
  var tmp_2 = new (Option())(tmp_0, 'SetAppend', tmp_1, VOID, 45, setOptions$lambda);
  var tmp_3 = Companion_instance_11.serializer_qelnde_k$(element);
  var tmp_4 = new (Option())(tmp_3, 'SetRemove', VOID, VOID, 45, setOptions$lambda_0);
  var tmp_5 = Companion_instance_12.serializer_qelnde_k$(element);
  var tmp_6 = new (Option())(tmp_5, 'SetRemoveInstances', VOID, VOID, 45, setOptions$lambda_1);
  var tmp_7 = Companion_instance_13.serializer_qelnde_k$(element);
  var tmp_8 = new (Option())(tmp_7, 'SetDropFirst', VOID, VOID, 45, setOptions$lambda_2);
  var tmp_9 = Companion_instance_14.serializer_qelnde_k$(element);
  var tmp_10 = new (Option())(tmp_9, 'SetDropLast', VOID, VOID, 45, setOptions$lambda_3);
  var tmp_11 = Companion_getInstance().serializer_qelnde_k$(element);
  return plus(tmp, listOf([tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, new (Option())(tmp_11, 'SetPerElement', VOID, VOID, 45, setOptions$lambda_4)]));
}
function listOptions(element) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = commonOptions(ListSerializer(element));
  var tmp_0 = Companion_instance_15.serializer_qelnde_k$(element);
  var tmp_1 = setOf('AppendList');
  var tmp_2 = new (Option())(tmp_0, 'ListAppend', tmp_1, VOID, 45, listOptions$lambda);
  var tmp_3 = Companion_instance_16.serializer_qelnde_k$(element);
  var tmp_4 = setOf('Remove');
  var tmp_5 = new (Option())(tmp_3, 'ListRemove', tmp_4, VOID, 45, listOptions$lambda_0);
  var tmp_6 = Companion_instance_17.serializer_qelnde_k$(element);
  var tmp_7 = setOf('RemoveInstances');
  var tmp_8 = new (Option())(tmp_6, 'ListRemoveInstances', tmp_7, VOID, 45, listOptions$lambda_1);
  var tmp_9 = Companion_instance_18.serializer_qelnde_k$(element);
  var tmp_10 = setOf('DropFirst');
  var tmp_11 = new (Option())(tmp_9, 'ListDropFirst', tmp_10, VOID, 45, listOptions$lambda_2);
  var tmp_12 = Companion_instance_19.serializer_qelnde_k$(element);
  var tmp_13 = setOf('DropLast');
  var tmp_14 = new (Option())(tmp_12, 'ListDropLast', tmp_13, VOID, 45, listOptions$lambda_3);
  var tmp_15 = Companion_getInstance_0().serializer_qelnde_k$(element);
  var tmp_16 = setOf('PerElement');
  return plus(tmp, listOf([tmp_2, tmp_5, tmp_8, tmp_11, tmp_14, new (Option())(tmp_15, 'ListPerElement', tmp_16, VOID, 45, listOptions$lambda_4)]));
}
function classOptionsReflective(inner) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = commonOptions(inner);
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.collections.mapIndexed' call
  var this_0 = ensureNotNull(get_serializableProperties(inner));
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(this_0.length);
  var index = 0;
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var tmp_0 = new (ModificationOnFieldSerializer())(item);
    var tmp_1 = item.get_name_woqyms_k$();
    var tmp_2 = item.get_annotations_20dirp_k$();
    var tmp$ret$4 = new (Option())(tmp_0, tmp_1, VOID, tmp_2, 70, classOptionsReflective$lambda(inner, _unary__edvuaz));
    destination.add_utx5q5_k$(tmp$ret$4);
  }
  return plus(tmp, destination);
}
function polymorphicOptions(supertype) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = commonOptions(supertype);
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = ensureNotNull(get_serializableOptions(supertype));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var discriminator = _SealedTypeDiscriminator___init__impl__jf77jn(item.serializer_1);
    var tmp0_serializer = new (ModificationIfIsTypeSerializer())(supertype, item.serializer_1);
    var tmp1_baseName = _SealedTypeDiscriminator___get_serialName__impl__x46m55(discriminator);
    var tmp2_alternativeNames = plus_0(item.secondaryNames_1, listOfNotNull(variantShortName(supertype, discriminator)));
    var tmp$ret$4 = new (Option())(tmp0_serializer, tmp1_baseName, tmp2_alternativeNames, VOID, 70, polymorphicOptions$lambda(discriminator));
    destination.add_utx5q5_k$(tmp$ret$4);
  }
  return plus(tmp, destination);
}
var ModificationOnFieldSerializerClass;
function ModificationOnFieldSerializer() {
  if (ModificationOnFieldSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(field) {
        super(field.get_name_woqyms_k$());
        this.field_1 = field;
      }
      getDeferred_py8w4r_k$() {
        return Companion_instance_3.serializer_qelnde_k$(this.field_1.get_serializer_u29zhh_k$());
      }
      inner_ysnprp_k$(it) {
        return it.modification_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_ysnprp_k$(it instanceof OnField() ? it : THROW_CCE());
      }
      outer_2yy1dm_k$(it) {
        return OnField().new_com_lightningkite_services_database_Modification_OnField_3hlyhh_k$(this.field_1, it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_2yy1dm_k$(it instanceof Modification() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationOnFieldSerializer');
    ModificationOnFieldSerializerClass = $;
  }
  return ModificationOnFieldSerializerClass;
}
var ModificationIfIsTypeSerializerClass;
function ModificationIfIsTypeSerializer() {
  if (ModificationIfIsTypeSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(supertype, type) {
        super('com.lightningkite.services.database.Modification.IfIsType');
        this.supertype_1 = supertype;
        this.type_1 = type;
      }
      getDeferred_py8w4r_k$() {
        return Companion_instance_3.serializer_qelnde_k$(this.type_1);
      }
      inner_uawbpk_k$(it) {
        return it.modification_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_uawbpk_k$(it instanceof IfIsType() ? it : THROW_CCE());
      }
      outer_2yy1dm_k$(it) {
        return IfIsType().new_com_lightningkite_services_database_Modification_IfIsType_tcecoc_k$(this.type_1, it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_2yy1dm_k$(it instanceof Modification() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationIfIsTypeSerializer');
    ModificationIfIsTypeSerializerClass = $;
  }
  return ModificationIfIsTypeSerializerClass;
}
function stringOptions$lambda(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof AppendString();
}
function comparableOptions$lambda(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof CoerceAtLeast();
}
function comparableOptions$lambda_0(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof CoerceAtMost();
}
function commonOptions$lambda(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof Nothing();
}
function commonOptions$lambda_0(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof Chain();
}
function commonOptions$lambda_1(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof Assign();
}
function nullableOptions$lambda(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof IfNotNull();
}
function numberOptions$lambda(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof Increment();
}
function numberOptions$lambda_0(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof Multiply();
}
function rawStringOptions$lambda(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return true;
}
function stringMapOptions$lambda(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof Combine();
}
function stringMapOptions$lambda_0(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof RemoveKeys();
}
function setOptions$lambda(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof SetAppend();
}
function setOptions$lambda_0(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof SetRemove();
}
function setOptions$lambda_1(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof SetRemoveInstances();
}
function setOptions$lambda_2(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof SetDropFirst();
}
function setOptions$lambda_3(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof SetDropLast();
}
function setOptions$lambda_4(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof SetPerElement();
}
function listOptions$lambda(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof ListAppend();
}
function listOptions$lambda_0(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof ListRemove();
}
function listOptions$lambda_1(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof ListRemoveInstances();
}
function listOptions$lambda_2(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof ListDropFirst();
}
function listOptions$lambda_3(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof ListDropLast();
}
function listOptions$lambda_4(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof ListPerElement();
}
function classOptionsReflective$lambda($inner, $index) {
  return (it) => {
    var tmp;
    if (it instanceof OnField()) {
      tmp = it.key_1.get_name_woqyms_k$() === $inner.get_descriptor_wjt6a0_k$().getElementName_u4sqmf_k$($index);
    } else {
      tmp = false;
    }
    return tmp;
  };
}
function polymorphicOptions$lambda($discriminator) {
  return (it) => {
    var tmp;
    if (it instanceof IfIsType()) {
      tmp = it.discriminator_1 === $discriminator;
    } else {
      tmp = false;
    }
    return tmp;
  };
}
var properties_initialized_ModificationSerialization_kt_dvyy1w;
function _init_properties_ModificationSerialization_kt__9j1qv2() {
  if (!properties_initialized_ModificationSerialization_kt_dvyy1w) {
    properties_initialized_ModificationSerialization_kt_dvyy1w = true;
    var tmp = comparableOptions(serializer(StringCompanionObject_instance));
    var tmp_0 = Companion_instance_20.serializer_9w0wvi_k$();
    stringOptions = plus(tmp, listOf_0(new (Option())(tmp_0, 'AppendString', VOID, VOID, 45, stringOptions$lambda)));
    cache = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
    numlist = setOf_0(['kotlin.Byte', 'kotlin.Short', 'kotlin.Int', 'kotlin.Long', 'kotlin.Float', 'kotlin.Double']);
  }
}
//region block: exports
export {
  ModificationAppendRawStringSerializer as ModificationAppendRawStringSerializer1syi2fot31cc3,
  ModificationAssignSerializer as ModificationAssignSerializer20mjm937imzn9,
  ModificationChainSerializer as ModificationChainSerializer1sjx3ub694ze6,
  ModificationCoerceAtLeastSerializer as ModificationCoerceAtLeastSerializer289b07fpxwnn2,
  ModificationCoerceAtMostSerializer as ModificationCoerceAtMostSerializer2e37y5d7g8cw6,
  ModificationCombineSerializer as ModificationCombineSerializer9vl8tr65gnfu,
  ModificationIfNotNullSerializer as ModificationIfNotNullSerializerjulstagon91h,
  ModificationIncrementSerializer as ModificationIncrementSerializer2uue65jxbk7cl,
  ModificationListAppendSerializer as ModificationListAppendSerializer26of7wz5yd6a0,
  ModificationListDropFirstSerializer as ModificationListDropFirstSerializer11ld8x0re3l6n,
  ModificationListDropLastSerializer as ModificationListDropLastSerializer6haifsne6eac,
  ModificationListRemoveInstancesSerializer as ModificationListRemoveInstancesSerializerq3lg7pkejk91,
  ModificationListRemoveSerializer as ModificationListRemoveSerializer1jblinhoeqtc7,
  ModificationMultiplySerializer as ModificationMultiplySerializer2zqnd64egc8a0,
  ModificationRemoveKeysSerializer as ModificationRemoveKeysSerializer3m9nk2caanh5o,
  ModificationSerializer as ModificationSerializer36sautdazlmsc,
  ModificationSetAppendSerializer as ModificationSetAppendSerializer25l37c29egm40,
  ModificationSetDropFirstSerializer as ModificationSetDropFirstSerializerh82esa6nfns5,
  ModificationSetDropLastSerializer as ModificationSetDropLastSerializer1qfw97w8jizwx,
  ModificationSetRemoveInstancesSerializer as ModificationSetRemoveInstancesSerializerxr9lu54tk9ad,
  ModificationSetRemoveSerializer as ModificationSetRemoveSerializer2loajeq81vlho,
  ModificationAppendStringSerializer_getInstance as ModificationAppendStringSerializer_getInstanceu0cqqe9pm1k,
};
//endregion

//# sourceMappingURL=ModificationSerialization.mjs.map
